import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import TwitterFollowButton from '../twitter-follow-button';
import NetworksIconsBar from '../networks-icons-bar/networks-icons-bar';
import WriterBadge from '../writer-badge';

import './team-member-box.css';

class TeamMemberBox extends Component {
  getContentByIsPartOfTeam() {
    let { 
      name,
      title,
      subTitle, 
      role,
      isPartOfTeam,
      isOnlyTwitterMediaShown = true, 
      ...rest 
    } = this.props;

    title = title || name;
    subTitle = subTitle || role;
    
    if (isPartOfTeam) {
      const linkUrl = `/team/${ name.toLowerCase().split(' ').join('_')}`;

      return (
        <div className='team-member-details-parts'>
          <Link to={ linkUrl } title={ name }>
            <div className='team-member-details-part'>
              <WriterBadge name={ name } />
            </div>

            <div className='team-member-details-part team-member-title'>{ title }</div>

            { 
              subTitle && 
                <div className='team-member-details-part team-member-sub-title'>{ subTitle }</div>
            }
          </Link>

          { 
            isOnlyTwitterMediaShown && rest.twitterUserId && 
              <div className="team-member-details-part follow-me-in-twitter-container">
                <TwitterFollowButton userId={ rest.twitterUserId } /> 
              </div>            
          }

          { 
            !isOnlyTwitterMediaShown && 
              <div className="team-member-details-part follow-me-in-twitter-container">
                <NetworksIconsBar rawIconsData={ rest } /> 
              </div>            
          }        
        </div>
      );
    }

    return (
        <div className='team-member-details-parts'>
          <div className='team-member-details-part'>
            <WriterBadge name={ name } />
          </div>

          <div className='team-member-details-part team-member-title'>{ title }</div>

          { 
            subTitle && 
              <div className='team-member-details-part team-member-sub-title'>{ subTitle }</div>
          }

          { 
            isOnlyTwitterMediaShown && rest.twitterUserId && 
              <div className="team-member-details-part follow-me-in-twitter-container">
                <TwitterFollowButton userId={ rest.twitterUserId } /> 
              </div>            
          }

          { 
            !isOnlyTwitterMediaShown && 
              <div className="team-member-details-part follow-me-in-twitter-container">
                <NetworksIconsBar rawIconsData={ rest } /> 
              </div>            
          }        
        </div>
    )
  }
  
  render() {
    const contentJSX = this.getContentByIsPartOfTeam();

    return (
      <article className='team-member-box'>
        {contentJSX}
      </article>
    );
  }
}

TeamMemberBox.propTypes = {
  name: PropTypes.string.isRequired,
  role: PropTypes.string,
  twitterUserId: PropTypes.string,
};

export default TeamMemberBox;